/**
 * Единый favicon и theme-color для всех тем (не переключается вместе с light/dark).
 * IDs должны совпадать с index.html <link id="...">.
 */
export function applyFaviconForTheme(_theme) {
  if (typeof document === 'undefined') return;
  const base = process.env.PUBLIC_URL || '';
  const paths = {
    svg: '/favicon.svg',
    p32: '/favicon-32x32.png',
    p192: '/favicon-192-light.png',
    p512: '/favicon-512-light.png',
    apple: '/apple-touch-icon-light.png',
    themeColor: '#2B7FFF',
  };

  const setHref = (id, path) => {
    const el = document.getElementById(id);
    if (el) el.setAttribute('href', `${base}${path}`);
  };

  setHref('favicon-svg', paths.svg);
  setHref('favicon-png-32', paths.p32);
  setHref('favicon-png-192', paths.p192);
  setHref('favicon-png-512', paths.p512);
  setHref('apple-touch-icon', paths.apple);

  const meta = document.getElementById('theme-color-meta');
  if (meta) meta.setAttribute('content', paths.themeColor);
}
